<template>
    <div class="menu-wrapper">
        <router-link to="/">
            <el-menu-item class="submenu-title-noDropdown-test">
                <img style="width:40px;height:40px" class="user-avatar"
                    src="../../../../../static/imgs/logo.png" alt="">
                <span slot="title">正畸智库</span>
            </el-menu-item>
        </router-link>
        <template v-for="item in routes" v-if="!item.hidden&&item.children">
            <router-link
                v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow"
                :key="item.children[0].name" :to="item.path+'/'+item.children[0].path">
                <el-menu-item :class="{'submenu-title-noDropdown':!isNest}"
                    :index="item.path+'/'+item.children[0].path">
                    <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon"
                        :icon-class="item.children[0].meta.icon"></svg-icon>
                    <span v-if="item.children[0].meta&&item.children[0].meta.title"
                        slot="title">{{item.children[0].meta.title}}</span>
                </el-menu-item>
            </router-link>

            <el-submenu v-else :key="item.name" :index="item.name||item.path">
                <template slot="title">
                    <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon">
                    </svg-icon>
                    <span v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title}}</span>
                </template>

                <template v-for="child in item.children" v-if="!child.hidden">
                    <sidebar-item v-if="child.children&&child.children.length>0" :key="child.path"
                        :is-nest="true" :routes="[child]" class="nest-menu"></sidebar-item>

                    <router-link v-else :key="child.name" :to="item.path+'/'+child.path">
                        <el-menu-item :index="item.path+'/'+child.path">
                            <svg-icon v-if="child.meta&&child.meta.icon"
                                :icon-class="child.meta.icon"></svg-icon>
                            <span v-if="child.meta&&child.meta.title"
                                slot="title">{{child.meta.title}}</span>
                        </el-menu-item>
                    </router-link>
                </template>
            </el-submenu>

        </template>
    </div>
</template>

<script>
export default {
    name: "SidebarItem",
    props: {
        routes: {
            type: Array,
        },
        isNest: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        hasOneShowingChildren(children) {
            const showingChildren = children.filter((item) => {
                return !item.hidden;
            });
            if (showingChildren.length === 1) {
                return true;
            }
            return false;
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.submenu-title-noDropdown-test {
    height: 60px;
    border-bottom: solid 1px #e6e6e6;
    padding-left: 10px !important;
    position: relative;
    .el-tooltip {
        padding: 0 10px !important;
    }
}
.user-avatar {
    width: 30px;
    height: 30px;
    border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue